import { defaultActionManagerRunner } from "./default_action_manager";
import { CreditCardPaymentMethod } from "../constants/campaigns";
export const CREATE_CAMPAIGN = "CREATE_CAMPAIGN";
export const EDIT_CAMPAIGN = "EDIT_CAMPAIGN";
export const GET_CAMPAIGN = "GET_CAMPAIGN";
export const GET_CAMPAIGNS_FOR_USER = "GET_CAMPAIGNS_FOR_USER";
export const CREATE_CAMPAIGN_ITEM = "CREATE_CAMPAIGN_ITEM";
export const UPDATE_CAMPAIGN_ITEM = "UPDATE_CAMPAIGN_ITEM";
export const SEND_CAMPAIGN = "SEND_CAMPAIGN";
export const CAMPAIGN_ONE_WEEK = "CAMPAIGN_ONE_WEEK";
export const GET_CAMPAIGN_STATS = "GET_CAMPAIGN_STATS";
export const GET_CAMPAIGN_WEEKLY_STATS = "GET_CAMPAIGN_WEEKLY_STATS";
export const PAUSE_CAMPAIGN_ITEM = "PAUSE_CAMPAIGN_ITEM";
export const UPDATE_CAMPAIGN_META = "UPDATE_CAMPAIGN_META";
export const GET_SAMPLE_AD_READ = "GET_SAMPLE_AD_READ";

export const createCampaign = campaign =>
  defaultActionManagerRunner({
    route: "campaigns",
    method: "post",
    actionName: CREATE_CAMPAIGN,
    body: campaign,
    auth: true,
  });

export const editCampaign = campaign =>
  defaultActionManagerRunner({
    route: `campaigns/${campaign.uuid}`,
    method: "post",
    actionName: EDIT_CAMPAIGN,
    body: campaign,
    auth: true,
  });

export const getCampaign = uuid => {
  return defaultActionManagerRunner({
    route: `campaigns/${uuid}`,
    actionName: GET_CAMPAIGN,
    auth: true,
  });
};
export const updateCampaignMeta = (campaignUUID, meta) => {
  return defaultActionManagerRunner({
    route: `campaigns/${campaignUUID}/metadata`,
    actionName: UPDATE_CAMPAIGN_META,
    auth: true,
    body: meta,
    method: "put",
  });
};

export const getCampaignsForUser = uuid =>
  defaultActionManagerRunner({
    route: `users/${uuid}/campaigns`,
    actionName: GET_CAMPAIGNS_FOR_USER,
    auth: true,
  });

export const createCampaignItems = (campaignUUID, body) =>
  defaultActionManagerRunner({
    route: `campaigns/${campaignUUID}/create-items`,
    body,
    auth: true,
    method: "post",
    actionName: CREATE_CAMPAIGN_ITEM,
  });

export const updateCampaignItems = (campaignUUID, itemUUIDToUPdateRequestMap) =>
  defaultActionManagerRunner({
    route: `campaigns/${campaignUUID}/update-items`,
    body: {
      updateRequestByCampaignItemUUID: itemUUIDToUPdateRequestMap,
    },
    auth: true,
    method: "post",
    actionName: UPDATE_CAMPAIGN_ITEM,
  });

export const sendCampaign = (campaignUUID, cardToken, paymentType = CreditCardPaymentMethod) =>
  defaultActionManagerRunner({
    route: `campaigns/${campaignUUID}/send`,
    body: {
      cardToken,
      paymentType,
    },
    auth: true,
    method: "post",
    actionName: SEND_CAMPAIGN,
  });

export const campaignOneWeek = campaignUUID =>
  defaultActionManagerRunner({
    route: `campaigns/${campaignUUID}/one-week`,
    auth: true,
    actionName: CAMPAIGN_ONE_WEEK,
  });

export const getCampaignStats = campaignUUID =>
  defaultActionManagerRunner({
    route: `advertiser_stats/campaigns/${campaignUUID}`,
    auth: true,
    actionName: GET_CAMPAIGN_STATS,
    actionData: {
      campaignUUID,
    },
  });

export const pauseCampaignItem = campaignItemUUID =>
  defaultActionManagerRunner({
    route: `campaign-items/${campaignItemUUID}/pause`,
    auth: true,
    method: "post",
    actionName: PAUSE_CAMPAIGN_ITEM,
  });

export const getSampleAdReads = showUUID =>
  defaultActionManagerRunner({
    route: `shows/${showUUID}/ad-reads`,
    auth: true,
    actionData: {
      showUUID,
    },
    actionName: GET_SAMPLE_AD_READ,
    silent: true,
  });
export const getCampaignWeeklyStats = campaignUUID =>
  defaultActionManagerRunner({
    route: `advertiser_stats/campaigns/${campaignUUID}/weekly`,
    auth: true,
    actionName: GET_CAMPAIGN_WEEKLY_STATS,
    actionData: {
      campaignUUID,
    },
  });
